export const ACTION_STATUS_OPTIONS = [
  { value: "OPEN", label: "Open" },
  { value: "IN_PROGRESS", label: "In Progress" },
  { value: "BLOCKED", label: "Blocked" },
  { value: "COMPLETED", label: "Completed" },
];

const ACTION_STATUS_LABELS = ACTION_STATUS_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

export const normalizeActionStatus = (status) => {
  if (status === null || status === undefined) return null;
  const normalized = String(status)
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");
  if (!normalized) return null;
  if (normalized === "COMPLETE") return "COMPLETED";
  return ACTION_STATUS_LABELS[normalized] ? normalized : null;
};

export const getActionStatusLabel = (status, fallbackLabel = "Unknown") => {
  const normalized = normalizeActionStatus(status);
  if (normalized) return ACTION_STATUS_LABELS[normalized];
  const rawValue = String(status || "").trim();
  return rawValue || fallbackLabel;
};

export const isCompletedActionStatus = (status) => normalizeActionStatus(status) === "COMPLETED";

export const isActionCompletionEvidenceNote = (note) => {
  if (!note || typeof note !== "object") return false;
  const body = String(note.body || "").trim();
  const author = String(note.author || "").trim().toLowerCase();
  return Boolean(body) && author !== "system";
};

const parseDueDate = (value) => {
  if (!value) return null;
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

export const isActionOverdue = (action, now = new Date()) => {
  if (!action?.due_date || isCompletedActionStatus(action?.status)) return false;
  const dueDate = parseDueDate(action.due_date);
  if (!dueDate) return false;

  const dueDateEnd = new Date(
    dueDate.getFullYear(),
    dueDate.getMonth(),
    dueDate.getDate(),
    23,
    59,
    59,
    999
  );

  return dueDateEnd.getTime() < now.getTime();
};

export const getActionDisplayStatus = (action, fallbackLabel = "Unknown") => {
  if (isActionOverdue(action)) return "Overdue";
  return getActionStatusLabel(action?.status, fallbackLabel);
};
